import React from "react";
import { useState } from "react";
import NumberFormat from "react-number-format";

import { Button, Stack, TextField } from "@mui/material";
import { PopoverContentProps } from "components/AiData/PopoverContent";

export const ValuePopoverContent: React.FC<PopoverContentProps> = ({
  openedCell,
  setOpenedCell,
  onChangeSpecificRecommendationValue
}) => {
  const [value, setValue] = useState<number | null>(
    typeof openedCell?.data.parameter.value === "number" ? openedCell?.data.parameter.value : null
  );

  return (
    <>
      <NumberFormat
        thousandSeparator
        isNumericString
        variant="outlined"
        size="small"
        sx={{ width: "100%" }}
        decimalScale={2}
        label="Value"
        customInput={TextField}
        value={value}
        onValueChange={({ floatValue }) => {
          if (typeof floatValue === "number") {
            setValue(floatValue);
          } else {
            setValue(null);
          }
        }}
      />

      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenedCell(null);
            setValue(null);
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={value === null}
          onClick={async () => {
            if (openedCell?.data && value !== null) {
              openedCell.data.parameter.id &&
                (await onChangeSpecificRecommendationValue({
                  id: openedCell.data.parameter.id,
                  field: "value",
                  value: value
                }));
            }
            setOpenedCell(null);
          }}
          variant="contained"
        >
          Apply
        </Button>
      </Stack>
    </>
  );
};
